<app-pan-form-control>
  <app-pan-floating-label>{{ label() }} </app-pan-floating-label>
  <ng-select
    data-testid="page-select-location-group-control"
    appendTo="body"
    [placeholder]="placeholder()"
    [bindLabel]="'name'"
    [virtualScroll]="true"
    [items]="visibleLocationGroups()"
    [multiple]="multi()"
    [ngModel]="selected()"
    (ngModelChange)="selected.set($event)"
    [loading]="isLoading()"
    loadingText="Loading location groups..."
    [disabled]="disabled()"
    clearAllText="Clear selection"
    [searchFn]="customSearchFn"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      @if (multi()) {
        <span class="ng-value-icon left" (click)="clear(item)">×</span>
      }

      <span [class.pl-1]="multi()" [matTooltip]="fullLabel(item)" [matTooltipDisabled]="!isTruncated(item)">
        {{ item.name | truncate: maxNameLength }}
        @if (showExternalId() && item.external_id) {
          ({{ item.external_id }})
        }
      </span>

      @if (item.is_national) {
        <app-pan-national-indicator class="shrink-0" [isNational]="item.is_national"></app-pan-national-indicator>
      }
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <div class="flex justify-between items-center gap-2">
        <div class="min-w-0 break-words">
          <p [matTooltip]="fullLabel(item)" [matTooltipDisabled]="!isTruncated(item)">
            {{ item.name | truncate: maxNameLength }}
            @if (showExternalId() && item.external_id) {
              ({{ item.external_id }})
            }
          </p>
        </div>

        @if (item.is_national) {
          <app-pan-national-indicator class="shrink-0" [isNational]="item.is_national"></app-pan-national-indicator>
        }
      </div>
    </ng-template>
  </ng-select>
</app-pan-form-control>
